import React from 'react';
import { steps } from '../data/copy';
export function Steps() {
  return <section aria-labelledby="como-funciona" className="w-full bg-cream" data-id="element-182" data-mp="18e3d9ng46p4e">
      <div className="mx-auto w-full max-w-4xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-183" data-mp="18g7ge366vk3m">
        <h2 id="como-funciona" className="font-display text-[1.6rem] font-bold leading-tight text-ink sm:text-3xl lg:text-[2.5rem]" data-id="element-184" data-mp="um6nvr5tytbp">
          Cómo funciona
        </h2>

        <ol className="mt-6 border-l border-sand sm:mt-10" data-id="element-185" data-mp="kn7f88l2exop">
          {steps.map((step, index) => <li key={step.title} className="relative pb-6 pl-6 last:pb-0 sm:pb-10 sm:pl-8" data-id="element-186" data-mp="powu5zbervi2" data-mpi={index}>
              <span className="absolute -left-[13px] top-0 flex h-6 w-6 items-center justify-center rounded-full bg-navy text-[11px] font-bold text-gold" aria-hidden="true" data-id="element-187" data-mp="bpf1v9ywm03y">
                {index + 1}
              </span>
              <h3 className="font-display text-lg font-bold text-ink sm:text-xl" data-id="element-188" data-mp="2a3qazjpa3zop">{step.title}</h3>
              <p className="mt-1 max-w-xl text-[0.95rem] leading-relaxed text-muted sm:mt-2 sm:text-base" data-id="element-189" data-mp="1qakegryox9l0">
                {step.text}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}